import { CONTACT_EMAIL } from "@/lib/apps";

const websiteData = {
  en: [
    "Name, e-mail address and message when you use the contact form. Your message is processed by our AI provider to write an automatic first reply, and forwarded to us so we can follow up.",
    "Your e-mail address and chosen app if you join a launch list (confirmed by e-mail). We use it only to tell you when that app launches, and every launch e-mail includes a link to unsubscribe.",
    "Basic technical data (browser type, pages visited) for security and privacy-friendly usage statistics.",
    "Your language preference, stored locally in your browser.",
  ],
  da: [
    "Navn, e-mailadresse og besked, når du bruger kontaktformularen. Din besked behandles af vores AI-leverandør for at skrive et automatisk første svar og videresendes til os, så vi kan følge op.",
    "Din e-mailadresse og valgte app, hvis du skriver dig op til en lanceringsliste (bekræftet via e-mail). Vi bruger den kun til at fortælle dig, når appen lanceres, og hver lancerings-e-mail indeholder et link til afmelding.",
    "Grundlæggende tekniske data (browsertype, besøgte sider) til sikkerhed og privatlivsvenlig statistik.",
    "Dit sprogvalg, gemt lokalt i din browser.",
  ],
};

export const buildPrivacy = (lang, app) => {
  const da = lang === "da";
  const name = app ? app.name : da ? "zenvio.dk-hjemmesiden" : "the zenvio.dk website";
  const collected = app ? app.privacy[lang] : websiteData[lang];
  return [
    {
      id: "who",
      h: da ? "Hvem vi er" : "Who we are",
      p: [da
        ? `Denne privatlivspolitik gælder for ${name}, udviklet og udgivet af ZenVio, et uafhængigt app-studie i Danmark (www.zenvio.dk). ZenVio er dataansvarlig for de oplysninger, der beskrives nedenfor.`
        : `This privacy policy applies to ${name}, developed and published by ZenVio, an independent app studio based in Denmark (www.zenvio.dk). ZenVio is the data controller for the information described below.`],
    },
    {
      id: "data",
      h: da ? "Hvilke data vi indsamler" : "What we collect",
      p: [da ? "Vi indsamler så lidt som muligt. Konkret drejer det sig om:" : "We collect as little as possible. Specifically:"],
      list: collected,
    },
    {
      id: "use",
      h: da ? "Hvordan vi bruger dem" : "How we use it",
      list: da
        ? ["For at levere og forbedre funktionerne.", "For at besvare dine henvendelser og supportspørgsmål.", "For at holde tjenesten sikker og stabil."]
        : ["To provide and improve the features.", "To answer your questions and support requests.", "To keep the service secure and stable."],
      p: [da ? "Vi sælger aldrig dine data, og vi bruger dem ikke til målrettet annoncering." : "We never sell your data, and we do not use it for targeted advertising."],
    },
    {
      id: "sharing",
      h: da ? "Deling og tredjeparter" : "Sharing & third parties",
      p: [da
        ? "Data deles kun med betroede leverandører, der er nødvendige for at drive tjenesten (f.eks. hosting og nedbrudsrapportering), og som er bundet af databehandleraftaler. Google Play og Apple App Store behandler data i henhold til deres egne privatlivspolitikker."
        : "Data is only shared with trusted providers needed to run the service (such as hosting and crash reporting), bound by data processing agreements. Google Play and the Apple App Store process data under their own privacy policies."],
    },
    {
      id: "storage",
      h: da ? "Opbevaring og sikkerhed" : "Storage & security",
      p: [da
        ? "Data opbevares kun så længe, det er nødvendigt til formålet, og beskyttes med kryptering og adgangskontrol. Data på din enhed slettes, når du afinstallerer appen."
        : "Data is kept only as long as needed for its purpose and is protected with encryption and access control. On-device data is removed when you uninstall the app."],
    },
    {
      id: "rights",
      h: da ? "Dine rettigheder" : "Your rights",
      p: [da ? "I henhold til GDPR har du ret til:" : "Under the GDPR you have the right to:"],
      list: da
        ? ["Indsigt i de data, vi har om dig.", "Berigtigelse eller sletning af dine data.", "Begrænsning af eller indsigelse mod behandling.", "Dataportabilitet.", "At klage til Datatilsynet (www.datatilsynet.dk)."]
        : ["Access the data we hold about you.", "Have your data corrected or deleted.", "Restrict or object to processing.", "Data portability.", "Lodge a complaint with the Danish Data Protection Agency (www.datatilsynet.dk)."],
    },
    {
      id: "children",
      h: da ? "Børn" : "Children",
      p: [da
        ? "Vores tjenester er ikke rettet mod børn under 13 år, og vi indsamler ikke bevidst data fra børn."
        : "Our services are not directed at children under 13, and we do not knowingly collect data from children."],
    },
    {
      id: "changes",
      h: da ? "Ændringer" : "Changes to this policy",
      p: [da
        ? "Vi kan opdatere denne politik. Væsentlige ændringer annonceres i appen eller på denne side, og datoen øverst opdateres."
        : "We may update this policy. Significant changes will be announced in the app or on this page, and the date above will be updated."],
    },
    {
      id: "contact",
      h: da ? "Kontakt" : "Contact",
      p: [da
        ? `Har du spørgsmål om privatliv, så skriv til ${CONTACT_EMAIL} eller brug kontaktformularen på www.zenvio.dk.`
        : `Questions about privacy? Write to ${CONTACT_EMAIL} or use the contact form on www.zenvio.dk.`],
    },
  ];
};
